// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"no-attempts_wrapper__IhvpX","title":"no-attempts_title__J_m5_","sub":"no-attempts_sub__ZnnES"};